import { render, staticRenderFns } from "./GerarLinkPaciente.vue?vue&type=template&id=b52a6396&scoped=true"
import script from "./GerarLinkPaciente.vue?vue&type=script&lang=js"
export * from "./GerarLinkPaciente.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b52a6396",
  null
  
)

export default component.exports